import { render, staticRenderFns } from "./AuralizationDownloadButton.vue?vue&type=template&id=5a974162&scoped=true&"
import script from "./AuralizationDownloadButton.vue?vue&type=script&lang=js&"
export * from "./AuralizationDownloadButton.vue?vue&type=script&lang=js&"
import style0 from "./AuralizationDownloadButton.vue?vue&type=style&index=0&id=5a974162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a974162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
